import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [line, setLine] = useState('');
  const [response, setResponse] = useState(null);

  const handleSubmit = async () => {
    try {
      const res = await axios.post('http://localhost:3001/build-verse', {
        line,
        mood: 'grief',
        genre: 'spoken_word',
        vocal_range: 'baritone'
      });
      setResponse(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="App">
      <h1>Sinister Ministry Verse Builder</h1>
      <textarea
        rows="4"
        cols="60"
        placeholder="Drop your verse here..."
        value={line}
        onChange={(e) => setLine(e.target.value)}
      />
      <br />
      <button onClick={handleSubmit}>Build Verse</button>

      {response && (
        <div className="results">
          <h2>Results</h2>
          <p><strong>Rhyme Suggestions:</strong> {response.rhyme_suggestions.join(', ')}</p>
          <p><strong>Syllable Count:</strong> {response.line_length_score}</p>
          <p><strong>Cadence Map:</strong> {response.cadence_map.join(' | ')}</p>
          <p><strong>Doctrine Flags:</strong></p>
          <ul>
            <li>Filler: {response.doctrine_flags.filler ? '❌' : '✅'}</li>
            <li>Drift: {response.doctrine_flags.drift ? '❌' : '✅'}</li>
            <li>Recycled Metaphor: {response.doctrine_flags.recycled_metaphor ? '❌' : '✅'}</li>
          </ul>
          <p><strong>Legacy Lock:</strong> {response.legacy_lock ? '🔒 Artifact Grade' : '🔓 Needs Work'}</p>
        </div>
      )}
    </div>
  );
}

export default App;
